import { useReasonLabels } from './hooks';
import { reasonLabel } from './utils';
import type { AutoMatchDecisionRow } from './types';

type ReasonCellProps = {
  row: Pick<
    AutoMatchDecisionRow,
    'outcome' | 'basisLabel' | 'suppressionReason'
  >;
};

/**
 * A decision's basis or suppression reason, named as the reason filter names it.
 * @param {ReasonCellProps} props - The decision
 * @return {JSX.Element} The label
 */
export function ReasonCell({ row }: ReasonCellProps) {
  const labels = useReasonLabels();
  return <>{reasonLabel(row, labels)}</>;
}
